export const dynamicPricing = {
  title: "Prezzi dinamici",
  loading: "Caricamento impostazioni…",
  status: {
    active: "Attivo",
    inactive: "Disattivato",
  },
  close: "Chiudi",
  unit: {
    label: "Alloggio",
    autoPill: "✦ Automatico dal tuo storico",
  },
  tabs: {
    calendario: "Calendario",
    precio: "Prezzo base",
    reglas: "Regole",
    aplicacion: "Applicazione",
  },
  weekdaysShort: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Gio",
    fri: "Ven",
    sat: "Sab",
    sun: "Dom",
  },
  cal: {
    stats: {
      adr: "ADR prev.",
      occupancy: "Occupazione",
      revenue: "Ricavi",
    },
    calculating: "Calcolo dei prezzi…",
    minStayShort: "min. {count}n | min. {count}n",
  },
  legend: {
    low: "Basso",
    base: "Base",
    high: "Alto",
    peak: "Picco",
    booked: "Prenotato",
    override: "Fisso",
  },
  why: {
    title: "Perché {price} {curr} · {day}",
    chip: "spiegazione",
    nights: "{count} notte | {count} notti",
    minStay: "Soggiorno minimo: {nights} · minimo {floor} / massimo {ceil} {curr}",
    hint: "Tocca un giorno per vedere come si scompone il prezzo.",
  },
  apply: {
    diffPrefix: "Con i prezzi suggeriti:",
    diffSuffix: "rispetto ai tuoi prezzi attuali per {month}.",
    apply: "Applica i prezzi",
    applying: "Applicazione…",
    applyNow: "Applica ora",
    enableToApply: "Attiva i Prezzi dinamici per applicarli.",
    enableFirst: "Attiva prima i Prezzi dinamici.",
    autoNote: {
      prefix: "✓ In modalità",
      mode: "Automatica",
      mid: "i prezzi si applicano",
      everyday: "ogni giorno",
    },
    result: {
      hotelPending: "Gli hotel (unità multiple) non sono ancora supportati in questa fase.",
      ok: "✓ Applicato {count} giorno ({from} → {to}) e inviato ai canali. | ✓ Applicati {count} giorni ({from} → {to}) e inviati ai canali.",
      failed: "Impossibile applicare i prezzi.",
    },
  },
  base: {
    title: "Prezzo base e limiti",
    desc: "Suggerito dal tuo storico. Il motore non esce mai da questo intervallo.",
    basePerNight: "Base / notte",
    min: "Minimo (soglia)",
    max: "Massimo (tetto)",
    rounding: "Arrotondamento",
  },
  rounding: {
    integer: "Intero",
    ends0: "Termina in 0",
    ends9: "Termina in 9",
    multiple5: "Mult. 5",
  },
  weekend: {
    title: "Weekend e soggiorno minimo",
    upliftLabel: "Maggiorazione weekend",
    daysLabel: "Giorni del weekend:",
    minStayLabel: "Soggiorno minimo (notti)",
    minStayNormal: "Standard",
    minStayWeekend: "Weekend / alta",
    orphanTitle: "Riempi le notti orfane",
    orphanDesc: "Soggiorni più brevi ({pct}% di sconto) nei vuoti di 1–2 notti.",
  },
  demand: {
    title: "Sensibilità alla domanda",
    desc: "Quanto l'occupazione e il ritmo delle prenotazioni influiscono sul prezzo.",
  },
  aggr: {
    low: "Conservativa",
    medium: "Media",
    high: "Aggressiva",
  },
  seasons: {
    title: "Stagioni",
    namePlaceholder: "Nome",
    monthDayPlaceholder: "MM-DD",
    add: "+ Aggiungi stagione",
  },
  events: {
    title: "Eventi (fiere, festival…)",
    suggestWithAI: "✨ Suggerisci con l'IA",
    suggesting: "Ricerca in corso…",
    namePlaceholder: "Nome",
    datePlaceholder: "YYYY-MM-DD",
    empty: "Nessun evento. Aggiungili manualmente o con l'IA.",
    add: "+ Aggiungi evento",
    suggestionsHead: "Suggerimenti IA{city} — controlla le date e aggiungi",
    addSuggestion: "+ Aggiungi",
    noSuggestions: "Nessun suggerimento (verifica che l'alloggio abbia una città impostata).",
  },
  demandRules: {
    title: "Regole di domanda",
    lastMinuteTitle: "Sconti last-minute",
    lastMinuteDesc: "Abbassa il prezzo delle date vicine ancora disponibili.",
    holidaysTitle: "Festività automatiche",
    holidaysDesc: "Applica +{pct}% nei giorni festivi nazionali.",
    occupancyTitle: "Aumenta in base all'occupazione",
    occupancyDesc: "Se il mese è pieno oltre il {threshold}%, aumenta il prezzo.",
    weeklyDiscount: "Sconto settim. (7+) %",
    monthlyDiscount: "Sconto mensile (28+) %",
  },
  application: {
    title: "Modalità e sincronizzazione",
    modeLabel: "Modalità di applicazione",
    modeSuggested: "Suggerita (controllo prima io)",
    modeAuto: "Automatica",
    syncTitle: "Sincronizza con i canali (Channex → Airbnb / Booking)",
    syncDesc: "Pubblica i prezzi calcolati sui tuoi canali.",
    horizonLabel: "Orizzonte di calcolo",
    horizonMonths: "{count} mesi",
  },
  save: {
    saved: "Salvato ✓",
    saving: "Salvataggio…",
    save: "Salva le modifiche",
  },
  errors: {
    forbidden: "Non hai accesso a questo alloggio.",
    loadFailed: "Impossibile caricare le impostazioni.",
    saveFailed: "Impossibile salvare. Controlla i campi.",
  },
};
